module.exports = __webpack_public_path__ + "static/media/SofiaProRegular.2f29a7da.eot";